import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';
type Props = {
  label: string;
  variant?: 'navy' | 'gold';
  note?: string;
  className?: string;
  id?: string;
};
export function CtaButton({
  label,
  variant = 'navy',
  note,
  className = '',
  id
}: Props) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-center text-[15px] font-extrabold uppercase tracking-[0.06em] leading-tight transition-[transform,background-color,box-shadow] duration-200 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:text-base';
  const styles = variant === 'gold' ? 'bg-gold-light text-ink shadow-[0_10px_30px_-12px_rgba(0,0,0,0.55)] hover:bg-gold-soft focus-visible:outline-gold-soft' : 'bg-navy text-cream shadow-[0_12px_30px_-14px_rgba(22,35,63,0.85)] hover:bg-navy-light focus-visible:outline-navy';
  return <div className={`w-full ${className}`} data-id="element-96" data-mp="157n5f3ghvpoi">
      <a id={id} href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-97" data-mp="35y7k6itup513">
        <span className="max-w-[19rem] sm:max-w-none" data-id="element-98" data-mp="39yho7py31ldb">{label}</span>
        <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-99" data-mp="3a0u4lyo6zno9" />
      </a>
      {note ? <p className={`mt-3 text-center text-[12.5px] font-medium leading-relaxed ${variant === 'gold' ? 'text-cream/70' : 'text-navy/60'}`} data-id="element-100" data-mp="3juugcjdzbr5y">
          {note}
        </p> : null}
    </div>;
}